import { render, staticRenderFns } from "./CommercialClaim.vue?vue&type=template&id=43e5a2a2&scoped=true&"
import script from "./CommercialClaim.vue?vue&type=script&lang=js&"
export * from "./CommercialClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e5a2a2",
  null
  
)

export default component.exports